import React from 'react';

function TextWithLineBreaks({ text }) {
  if (text && text.split) {
    return (
      <div>
        {text.split('\\n').map((item, index) => (
          <React.Fragment key={index}>
            {item}
            <br />
          </React.Fragment>
        ))}
      </div>
    );
  
  } else {
    return "";
  }
}

export default TextWithLineBreaks;